import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import success from "../assets/success.png";
import style from "../styles/checkout-pages.module.scss";
import Button from "../components/button";
import { BottomSpacer } from "../components/spacer";

const getStoredItem = () => {
  const storedItems = localStorage.getItem("item");

  if (!storedItems) {
    return null;
  }

  try {
    return JSON.parse(storedItems);
  } catch (error) {
    console.log("Failed to parse stored booking item", error);
    return null;
  }
};

export default function FreeQuoteSuccess() {
  const item = getStoredItem();

  useEffect(() => {
    localStorage.setItem("emailSent", "true");
  }, []);

  let navigate = useNavigate();

  const handleClick = () => {
    let path = `/book-now`;
    navigate(path);
  };

  return (
    <div className={style.container}>
      <img src={success} className={style.icon} alt="green tick" />
      <h2 className={style.title}>
        Your free quotation with one of our electricians is booked!
      </h2>
      {item ? (
        <div className={style.bookingDetails}>
          <p>Your booking details:</p>
          <table>
            <tbody>
              <tr>
                <td>Name:</td>
                <td className={style.rightAlign}>{item.customerName}</td>
              </tr>
              <tr>
                <td>Booking ID:</td>
                <td className={style.rightAlign}>{item.bookingID}</td>
              </tr>
              <tr>
                <td>Service:</td>
                <td className={style.rightAlign}>{item.productName}</td>
              </tr>
              <tr>
                <td>Paid:</td>
                <td className={style.rightAlign}>£{item.price}</td>
              </tr>
              <tr>
                <td>Date:</td>
                <td className={style.rightAlign}>{item.emailDate} </td>
              </tr>
              <tr>
                <td>Time:</td>
                <td className={style.rightAlign}>{item.emailStartTime}</td>
              </tr>
              <tr>
                <td>Address:</td>
                <td className={style.rightAlign}>
                  {item.address?.line1}, {item.address?.postcode}
                </td>
              </tr>
            </tbody>
          </table>
          <p>
            Keep an eye on your inbox - we've sent your email confirmation
            there. In case you don't find it there, we recommend checking your
            junk mail.
          </p>
        </div>
      ) : (
        <div className={style.bookingDetails}>
          <p>
            We could not load your booking details after checkout. Please
            contact us and include your payment reference so we can confirm your
            booking manually.
          </p>
        </div>
      )}
      <Button onClick={handleClick}>Book another service</Button>
      <p className={style.title}>
        Need to talk to someone about your booking?{" "}
        <a href="/contact-us">Contact us</a>
      </p>
      <BottomSpacer />
    </div>
  );
}
